import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@18.19.112_@vue+compiler-sf_4jbe4b47lt2s7wr6ulzesl642e/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}